import {css} from 'styled-components';

import {Colors} from 'styles/Colors';

const headingDebuggingStyle = ({color, size, tag}: {color: string; size: string; tag: string}) => css`
  ${tag}::after {
    color: ${color};
    font-size: ${size};
    bottom: ${size};
    content: '${tag}';
    position: relative;
    background-color: ${Colors.LIGHT_GREEN};
  }
`;

const headingDebuggingStyles = ({enableHeadingDebugging}: {enableHeadingDebugging: boolean}) =>
  enableHeadingDebugging
    ? css`
        ${headingDebuggingStyle({color: 'red', size: '1.5rem', tag: 'h1'})}
        ${headingDebuggingStyle({color: 'green', size: '1rem', tag: 'h2'})}
        ${headingDebuggingStyle({color: 'blue', size: '0.75rem', tag: 'h3'})}
        ${headingDebuggingStyle({color: 'purple', size: '0.6rem', tag: 'h4'})}
        ${headingDebuggingStyle({color: 'black', size: '0.5rem', tag: 'h5'})}
      `
    : undefined;

export default headingDebuggingStyles;
